
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/danilo-leal-joining",
      function () {
        return require("private-next-pages/blog/danilo-leal-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/danilo-leal-joining"])
      });
    }
  